<template>
  <header class="header">
    <voucher-segment-create-modal />
  </header>
</template>
 
<script>
import VoucherSegmentCreateModal from "@components/modules/voucher/segment/create/modal/VoucherSegmentCreateModal.vue";

export default {
  components: {
    VoucherSegmentCreateModal,
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
